module.exports = __webpack_public_path__ + "img/logo-light.d0fc71b5.png";